<template>
    <div class="w-full px-12 mt-48 xs:w-1/2 sm:w-1/3">
        <!--    CARD START-->
        <div>
            <div class="flex items-center justify-center h-full p-20 border-2 border-white border-dashed rounded-md py-96">
                <div>
                    <div class="flex items-center justify-center">
                        <div class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-200 rounded-full">
                            <div class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
                                <IconStarSVG class="w-24 h-24" />
                            </div>
                        </div>
                    </div>

                    <button
                        @click="initModal()"
                        class="mt-16 block font-normal text-center underline title-lg text-primary hover:text-blue-300 transition.all duration-200 ease-in-out"
                    >
                        {{ $t('info.add_bonuscard') }}
                    </button>
                </div>
            </div>
        </div>
        <!--    CARD END-->

        <!--    MODAL START-->
        <div class="micromodal" id="add_bonus_card" aria-hidden="true">
            <div class="px-10 micromodal__overlay" tabindex="-1">
                <div class="micromodal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                    <header class="micromodal__header">
                        <h2 class="pb-24 pr-48 title-2xl text-primary">{{ $t('info.add_bonuscard') }}</h2>

                        <button class="micromodal__close" aria-label="Close modal" data-micromodal-close :disabled="loading">
                            <span class="flex-shrink-0 block w-20 h-20 text-black pointer-events-none fill-current">
                                <IconXSVG />
                            </span>
                        </button>
                    </header>
                    <div class="micromodal__content">
                        <!--                        <AlertSummary v-show="showAlert" :main-text="this.alertMessage"-->
                        <!--                                      secondary-text="Vormi salvestamisel esines viga. Palun kontrolli sisestatud andmeid."-->
                        <!--                                      alert-classes="e5-form-error-summary&#45;&#45;error"/>-->
                        <div class="flex self-form-wrap">
                            <div :class="['w-full self-form-wrap-item', { 'e5-error': invalidCardName }]">
                                <label class="e5-form-label" for="name"
                                    >{{ $t('info.card_name') }} <span class="e5-form-field-required">({{ $t('info.required') }})</span
                                    ><span class="e5-form-field-required">*</span></label
                                >
                                <div class="relative">
                                    <input
                                        @blur="checkCardName()"
                                        type="text"
                                        id="name"
                                        placeholder=""
                                        name="name"
                                        v-model="cardName"
                                        class="e5-input"
                                    />
                                </div>
                            </div>

                            <div :class="['w-full self-form-wrap-item', { 'e5-error': invalidCardNumber }]">
                                <label class="e5-form-label" for="number"
                                    >{{ $t('dashboard.bonus_card.card_no') }}
                                    <span class="e5-form-field-required">({{ $t('info.required') }})</span
                                    ><span class="e5-form-field-required">*</span></label
                                >
                                <div class="relative">
                                    <input
                                        @blur="checkCardNumber()"
                                        type="text"
                                        id="number"
                                        placeholder=""
                                        name="number"
                                        v-model="cardNumber"
                                        class="e5-input"
                                    />
                                </div>
                            </div>

                            <Dob
                                :label="$t('info.valid_until')"
                                @update:date="updatevalidUntilDate"
                                :disable="isIndefinite.length === 1"
                                has-past-and-future-dates
                                :uniqueId="'add-bonus-card-valid-until-date'"
                            />
                            <div class="w-full self-form-wrap-item">
                                <input
                                    class="e5-checkbox"
                                    type="checkbox"
                                    id="addBonuscardIndefinite"
                                    name="addBonuscardIndefinite"
                                    value="2999-12-31"
                                    v-model="isIndefinite"
                                />
                                <label class="" for="addBonuscardIndefinite">
                                    {{ $t('info.indefinite_end_date') }}
                                </label>
                            </div>
                            <div :class="['w-full self-form-wrap-item', { 'e5-error-choices': invalidToplevel }]">
                                <label class="e5-form-label" for="toplevel"
                                    >{{ $t('reports.form.service_groups') }}
                                    <span class="e5-form-field-required">({{ $t('info.required') }})</span
                                    ><span class="e5-form-field-required">*</span></label
                                >
                                <div class="relative">
                                    <div class="self-form-select-wrap">
                                        <select name="toplevel" id="toplevel" multiple class="self-multiselect-add-bonuscard"></select>
                                    </div>
                                </div>
                            </div>

                            <div class="flex items-center justify-between px-8 pt-16 w-full">
                                <div>
                                    <button @click="saveBonuscard" class="self-btn-primary" :disabled="!isFormOk || loading">
                                        {{ !loading ? $t('info.save') : '' }}
                                        <span v-if="loading" class="grow-shrink-dot bg-yellow-300" role="status" aria-hidden="true"></span>
                                        <span v-else class="text-yellow-300 self-btn-primary__icon">
                                            <IconArrowAltSVG />
                                        </span>
                                    </button>
                                </div>

                                <div>
                                    <button data-micromodal-close class="self-btn-plain" :disabled="loading">
                                        <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                                            <IconXSVG />
                                        </span>
                                        <span class="self-btn-plain__text">{{ $t('info.cancel') }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--    MODAL END-->
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import IconStarSVG from '@/assets/static/icons-src/icon-star.svg';
import IconXSVG from '@/assets/static/icons-src/icon-x.svg';
import IconArrowAltSVG from '@/assets/static/icons-src/icon-arrow-alt.svg';
import Dob from '@/components/info-view-components/Dob.vue';
import { ISaveBonuscardRequest } from '@/domain/ISaveInfo';
import store from '@/store';
import Choices from 'choices.js';
import $ from 'jquery';
import { IToplevel } from '@/domain/IToplevel';
import AlertSummary from '@/components/AlertSummary.vue';
import MicroModal from 'micromodal';
import moment from 'moment';
import UtilsMixin from '@/scripts/utils';

@Component({
    components: {
        AlertSummary,
        IconStarSVG,
        IconXSVG,
        IconArrowAltSVG,
        Dob
    },
    mixins: [UtilsMixin]
})
export default class AddBonusCard extends Vue {
    cardName = '';
    cardNumber = '';
    cardValidUntil = '';
    selectedToplevel = '';
    choices = null;
    isIndefinite = [];

    invalidCardName = false;
    invalidCardNumber = false;
    invalidToplevel = false;
    alertMessage = '';
    loading = false;

    get isFormOk() {
        return (
            this.cardName?.length &&
            this.cardNumber?.length &&
            (this.cardValidUntil?.length || this.isIndefinite.length) &&
            this.selectedToplevel?.length &&
            this.selectedToplevel?.length
        );
    }

    initModal() {
        this.initMultiSelects();
        this.cardName = '';
        this.cardNumber = '';
        this.selectedToplevel = '';
        this.alertMessage = '';
        this.isIndefinite = [];
        this.invalidCardName = false;
        this.invalidCardNumber = false;
        this.invalidToplevel = false;
        this.updatevalidUntilDate(moment().format('YYYY-MM-DD'));
        this.openModal('add_bonus_card');
    }

    // Type Declarations for TypeScript to tell that these methods exist in utils.ts
    openModal!: (id: string) => void;

    private initMultiSelects() {
        if (this.choices) {
            this.choices.destroy();
        }
        const selectElement = document.querySelector('.self-multiselect-add-bonuscard') as HTMLSelectElement;
        if (selectElement === null) return;
        const placeholderText = this.$t('reports.form.choose') as string;

        this.choices = new Choices(document.querySelector('.self-multiselect-add-bonuscard'), {
            removeItemButton: true,
            itemSelectText: placeholderText,
            maxItemCount: 2,
            maxItemText: this.$t('reports.form.only_one_can_be_selected') as string,
            noChoicesText: this.$t('reports.form.no_choices_to_choose_from') as string,
            allowHTML: true
        });

        this.choices.passedElement.element.addEventListener(
            'change',
            (event) => {
                const selectedValues = $(event.target).val() as string[];
                if (selectedValues.length > 1) {
                    // Convert the HTMLSelectElement to an array-like object
                    const options = Array.from(selectElement.options);

                    // Find the option with the specified value and remove it
                    const optionToRemove = options.find((option) => option.value === selectedValues[0]);
                    if (optionToRemove) {
                        selectElement.removeChild(optionToRemove);
                    }

                    // Update Choices.js instance to reflect the changes
                    this.choices.removeActiveItemsByValue(selectedValues[0]);
                    selectedValues.splice(0, 1);
                    this.choices.setChoiceByValue(selectedValues);
                }
                this.invalidToplevel = selectedValues.length === 0;
                this.selectedToplevel = selectedValues[0];
                this.choices.hideDropdown();
            },
            false
        );

        // Set the initial values for the choices component
        const toplevels: IToplevel[] = this.$store.state.toplevel;
        // Filter out unwanted toplevels
        const filteredToplevels = toplevels.filter((toplevel) => ['Air', 'Hotel', 'Car', 'Ferry', 'Other'].includes(toplevel.toplevel_id));
        this.choices.setChoices(
            filteredToplevels.map((toplevel) => ({
                value: toplevel.toplevel_id,
                label: toplevel.toplevel_name,
                selected: false
            })),
            'value',
            'label',
            false
        );
        this.selectedToplevel = '';
    }

    updatevalidUntilDate(date: string) {
        this.cardValidUntil = date;
    }

    async saveBonuscard() {
        this.loading = true;
        const request: ISaveBonuscardRequest = {
            customerId: store.getters.getCustomerInfo.customerid,
            bonuscardId: null,
            bonuscardName: this.cardName,
            bonuscardNumber: this.cardNumber,
            bonuscardValidUntil: this.isIndefinite.length === 0 ? this.cardValidUntil : this.isIndefinite[0],
            toplevel: this.selectedToplevel
        };
        const success = await store.dispatch('saveBonuscard', request);
        if (!success) {
            this.requestErrorFunction();
            MicroModal.close('add_bonus_card');
            this.loading = false;
            return;
        }
        MicroModal.close('add_bonus_card');
        await store.dispatch('updateCustomerInfo');
        this.loading = false;
    }

    private requestErrorFunction() {
        Vue.notify({
            group: 'api',
            title: 'Server error',
            text: 'Error while while processing bonuscard requests',
            type: 'warn'
        });
    }

    checkCardName() {
        this.invalidCardName = this.cardName === '';
    }

    checkCardNumber() {
        this.invalidCardNumber = this.cardNumber === '';
    }
}
</script>

<style scoped>
.e5-error .self-form-select-wrap select {
    border: 1px solid red;
}
</style>
